export default "__VITE_ASSET__CqxLnK8t__"